<script setup lang="ts">
import lodashToNumber from 'lodash-es/toNumber';

export interface StoryblokNumberProps {
    blok: StoryblokNumber;
}

// PROPS
const { blok } = defineProps<StoryblokNumberProps>();

// COMPOSABLES
const { classes } = useStoryblokComponentClass(() => ({ color: blok.color, fontSize: blok.size }));

// DATA
const label = computed(() => (blok.label ? formatBlockIndex(lodashToNumber(blok.label)) : undefined));
</script>

<template>
    <div v-if="!!label" class="font-bold" :class="classes">{{ label }}</div>
</template>
